(()=>{
 function init(){
  const header=document.querySelector('.fsh-header');
  if(header&&!header.dataset.initialized){
   header.dataset.initialized='true';
   const toggle=header.querySelector('.fsh-menu-button'), menu=header.querySelector('.fsh-mobile-menu');
   function close(returnFocus=false){toggle.setAttribute('aria-expanded','false');menu.hidden=true;if(returnFocus)toggle.focus();}
   toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));menu.hidden=!open;});
   menu.addEventListener('click',event=>{if(event.target.closest('a'))close();});
   document.addEventListener('click',event=>{if(!header.contains(event.target))close();});
   header.addEventListener('keydown',event=>{if(event.key==='Escape')close(true);});
   matchMedia('(min-width:701px)').addEventListener('change',event=>{if(event.matches)close();});
  }
  const hero=document.querySelector('.fsh-hero');
  if(hero&&!hero.dataset.initialized){
   hero.dataset.initialized='true';
   const slides=[...hero.querySelectorAll('[data-home-slide]')],dots=[...hero.querySelectorAll('[data-home-dot]')];
   dots.forEach((dot,index)=>dot.addEventListener('click',()=>{
    slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.classList.toggle('is-active',i===index);});
    dots.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
   }));
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
